import Cookies from 'js-cookie'
import mobilFooter from './components/mobilFooter/mobilFooter.vue'
import anime from 'animejs'
// import { getParticipation } from './services'

export default {
  name: 'App',
  components: {
    mobilFooter
  },
  data() {
    return {
      mainMenuButton: false,
      auth: '',
      predictionCountdown: 0,
      predictionTimerInterval: null,
      predictionSessionExpiredHandled: false
    }
  },
  computed: {
    routeBackgroundClass() {
      return this.$route?.meta?.bgClass || 'bg-mobil-default'
    },
    hasPredictionCountdown() {
      return this.predictionCountdown > 0
    },
    predictionCountdownLabel() {
      const totalSeconds = Math.max(0, Math.floor(this.predictionCountdown / 1000))
      const minutes = Math.floor(totalSeconds / 60)
      const seconds = totalSeconds % 60
      return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
    }
  },
  methods: {
    getPredictionDeadline() {
      const value = localStorage.getItem('prediction_timer_deadline')
      const parsed = Number(value)
      return Number.isFinite(parsed) ? parsed : 0
    },
    clearPredictionTimer() {
      localStorage.removeItem('prediction_timer_deadline')
      localStorage.removeItem('prediction_timer_started')
      this.predictionCountdown = 0
      this.predictionSessionExpiredHandled = false
    },
    clearAllCookies() {
      document.cookie.split(';').forEach(cookie => {
        const cookieName = cookie.split('=')[0].trim()
        if (!cookieName) {
          return
        }

        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`
      })
    },
    clearAllClientState({ preservePredictions = false } = {}) {
      const preservedPredictions = preservePredictions ? localStorage.getItem('predicciones') : null

      this.clearPredictionTimer()
      localStorage.clear()

      if (preservedPredictions) {
        localStorage.setItem('predicciones', preservedPredictions)
      }

      sessionStorage.clear()
      this.clearAllCookies()
      this.auth = false
    },
    handlePredictionTimerExpired() {
      if (this.predictionSessionExpiredHandled) {
        return
      }

      this.predictionSessionExpiredHandled = true
      this.clearAllClientState({ preservePredictions: true })
      this.$router.push('/iniciar-sesion').catch(() => {})
    },
    updatePredictionCountdown() {
      const deadline = this.getPredictionDeadline()

      if (!deadline) {
        this.predictionCountdown = 0
        return
      }

      const remaining = deadline - Date.now()
      if (remaining <= 0) {
        this.predictionCountdown = 0
        this.handlePredictionTimerExpired()
        return
      }

      this.predictionCountdown = remaining
    },
    startPredictionCountdownWatcher() {
      if (this.predictionTimerInterval) {
        clearInterval(this.predictionTimerInterval)
      }

      this.updatePredictionCountdown()
      this.predictionTimerInterval = setInterval(() => {
        this.updatePredictionCountdown()
      }, 1000)
    },
    redirigir(name) {
      this.$router.push({ name })
    },
    abrir(url) {
      window.open(url, '_blank')
    },
    toggleMenu() {
      this.mainMenuButton = !this.mainMenuButton
      this.animateButton()
    },
    animateButton() {
      if (this.mainMenuButton) {
        // Animación para transformar en X
        anime({
          targets: '.hamburger-icon span:nth-child(1)',
          rotate: [0, 50],
          translateY: [0, 12],
          duration: 500,
          easing: 'easeInOutQuad'
        })
        anime({
          targets: '.hamburger-icon span:nth-child(2)',
          opacity: [1, 0],
          duration: 500,
          easing: 'easeInOutQuad'
        })
        anime({
          targets: '.hamburger-icon span:nth-child(3)',
          rotate: [0, -50],
          translateY: [0, -12],
          duration: 500,
          easing: 'easeInOutQuad'
        })
      } else {
        // Animación para volver al ícono de hamburguesa
        anime({
          targets: '.hamburger-icon span:nth-child(1)',
          rotate: [50, 0],
          translateY: [8, 0],
          duration: 500,
          easing: 'easeInOutQuad'
        })
        anime({
          targets: '.hamburger-icon span:nth-child(2)',
          opacity: [0, 1],
          duration: 500,
          easing: 'easeInOutQuad'
        })
        anime({
          targets: '.hamburger-icon span:nth-child(3)',
          rotate: [-50, 0],
          translateY: [-8, 0],
          duration: 500,
          easing: 'easeInOutQuad'
        })
      }
    },
    logOut() {
      Cookies.remove('predictor')
      this.clearAllClientState()
      setTimeout(() => {
        this.$router.push('/')
      }, 2000)
    }
  },
  mounted() {
    if (document.cookie.includes('predictor')) {
      this.auth = true
    }
    const navIcons = document.querySelectorAll('#nav-icon1, #nav-icon2, #nav-icon3, #nav-icon4')
    navIcons.forEach(navIcon => {
      navIcon.addEventListener('click', () => {
        navIcon.classList.toggle('open')
        const containerMenuMobileOptions = document.querySelector('.container-menu-mobile-options')

        if (containerMenuMobileOptions.classList.contains('show')) {
          containerMenuMobileOptions.classList.remove('show')
          containerMenuMobileOptions.classList.add('hide')

          // Esperar a que la animación termine antes de ocultar el elemento
          setTimeout(() => {
            containerMenuMobileOptions.style.display = 'none'
            containerMenuMobileOptions.classList.remove('hide')
          }, 300) // La duración de la transición en milisegundos
        } else {
          containerMenuMobileOptions.style.display = 'flex'
          setTimeout(() => {
            containerMenuMobileOptions.classList.add('show')
          }, 10) // Pequeño retraso para permitir que el navegador registre el cambio de display
        }
      })
    })

    // Cerrar el menú móvil al pasar a vista escritorio
    const DESKTOP_BREAKPOINT = 768
    const closeMenuOnResize = () => {
      if (window.innerWidth >= DESKTOP_BREAKPOINT) {
        const containerMenuMobileOptions = document.querySelector('.container-menu-mobile-options')
        if (containerMenuMobileOptions && containerMenuMobileOptions.classList.contains('show')) {
          containerMenuMobileOptions.classList.remove('show')
          containerMenuMobileOptions.classList.add('hide')
          setTimeout(() => {
            containerMenuMobileOptions.style.display = 'none'
            containerMenuMobileOptions.classList.remove('hide')
          }, 300)
          // Resetear todos los iconos hamburguesa
          const navIcons = document.querySelectorAll('#nav-icon1, #nav-icon2, #nav-icon3, #nav-icon4')
          navIcons.forEach(icon => icon.classList.remove('open'))
          // Resetear animación del botón hamburguesa
          if (this.mainMenuButton) {
            this.mainMenuButton = false
            this.animateButton()
          }
        }
      }
    }
    window.addEventListener('resize', closeMenuOnResize)
    this.startPredictionCountdownWatcher()
    this.$once('hook:beforeDestroy', () => {
      if (this.predictionTimerInterval) {
        clearInterval(this.predictionTimerInterval)
      }
      window.removeEventListener('resize', closeMenuOnResize)
    })
  }
}
